import { Layout } from "antd";
import formatDateTime from "helpers/formatDateTime";
import { useTranslation } from "react-i18next";
import buildData from "version";
import styles from "./Footer.module.less";

function Footer(): JSX.Element {
  const { t } = useTranslation();

  return (
    <Layout.Footer className={styles.wrapper}>
      <p className={styles.copyright}>{t("footer.copyright_text")}</p>
      <p className={styles.version}>
        {buildData.commit === "local" ? (
          <span>
            local build{" "}
            {formatDateTime({ date: new Date(), isLocalTimezone: true })}
          </span>
        ) : (
          <span>
            Version #{buildData.commit} Build #{buildData.build}{" "}
            {formatDateTime({
              date: new Date(buildData.dateTime),
              isLocalTimezone: true,
            })}
          </span>
        )}
      </p>
    </Layout.Footer>
  );
}

export default Footer;
